import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FlexBoxCol } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/features/domru-bonus/styled';

const ICON_SIZE = '65px';
const ICON_PATH = '/static/images/icons/';

export const CardWrapper = styled(FlexBoxCol)`
    width: 433px;
    padding: 32px 20px 32px 43px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    border-radius: 16px;
    background: ${COLORS.white};

    @media (max-width: ${breakPoints.laptop}) {
        width: 340px;
        flex-direction: column;
        align-items: flex-start;
        padding: 23px 20px 16px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        padding: 24px 20px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        max-width: unset;
        width: 100%;
        margin-bottom: 12px;
    }

    &:not(:last-child) {
        margin-right: 32px;

        @media (max-width: ${breakPoints.laptop}) {
            margin-right: 20px;
        }

        @media (max-width: ${breakPoints.mobile}) {
            margin-right: 0;
            margin-bottom: 12px;
        }
    }
`;

export const CardIcon = styled.div<{ icon: string }>`
    min-width: ${ICON_SIZE};
    height: ${ICON_SIZE};
    margin-right: 23px;
    background: url(${p => ICON_PATH + p.icon}) 0 0 / cover no-repeat;

    @media (max-width: ${breakPoints.laptop}) {
        margin-bottom: 23px;
    }
`;

export const CardText = styled.div`
    ${FONTS.M};

    @media (max-width: ${breakPoints.mobile}) {
        max-width: 250px;
    }
`;
